export const manualAdmin: Record<string, readonly [string, string, string, string]> = {};
